
import React from 'react';
import { Link } from 'react-router-dom';
import { IMAGE_PATHS } from '@/utils/imagePaths';
import { RemoteImage } from '@/components/common/ResponsiveImage';
import { supabaseImgSrc, supabaseSrcSet } from '@/lib/images';

const INTRO_PATH = "e25f76f3-a488-4394-b062-23ec9f7e183e.png" as const;

const IntroSection = () => {
  return (
    <section className="section bg-white py-8 md:py-10">
      <div className="container-custom">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 items-center">
          <div className="animate-fade-in">
            <h2 className="mb-3">Trusted Electrical Contractor Across Central Florida</h2>
            <p className="mb-3 text-sm md:text-base">
              Elevation Electrical serves homeowners and businesses across Volusia, Seminole, Orange,
              Lake and Flagler counties — Deltona, Sanford, Daytona Beach, New Smyrna Beach, Lake Mary,
              Orlando, DeLand, Ormond Beach and 25+ more cities. Led by Principal Owners Keith Stephenson
              and Sean Abernethy, our licensed team (EC13011028) delivers exceptional workmanship on
              projects of all sizes from our Lake Helen base.
            </p>
            <p className="mb-4 text-sm md:text-base">
              From new construction electrical systems to remodels, commercial installations to residential services, we have the expertise to handle all your electrical needs with precision and professionalism.
            </p>
            <div className="flex flex-wrap gap-3">
              <Link to="/about" className="btn-primary">
                About Our Company
              </Link>
              <Link to="/services" className="btn-outline">
                Explore Services
              </Link>
            </div>
          </div>
          
          <div className="rounded-lg overflow-hidden shadow-md h-[250px] md:h-[300px]">
            <RemoteImage
              src={supabaseImgSrc(IMAGE_PATHS[INTRO_PATH], { width: 960, format: "webp" })}
              srcSet={supabaseSrcSet(IMAGE_PATHS[INTRO_PATH], [320, 640, 960], "webp")}
              sizes="(max-width: 1024px) 100vw, 50vw"
              width={960}
              height={640}
              alt="Licensed and insured Elevation Electrical, LLC professional electrician performing high-quality residential electrical work in Central Florida home"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default IntroSection;
